<section class="content">
  <div class="container-fluid">
    <div class="block-header">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <ul class="breadcrumb breadcrumb-style ">
            <li class="breadcrumb-item">
              <h4 class="page-title">Route</h4>
            </li>
          
          </ul>
        </div>
      </div>
    </div>
    <!-- <app-maser-page-header></app-maser-page-header> -->
    <div *ngIf="!data_loaded">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [value]="value">
      </mat-progress-spinner>
    </div>
    <span *ngIf="data_loaded">
      <div class="row">
        <div class="col-7">
          <button mat-fab color="primary" (click)="registerRoute()">
            <mat-icon aria-hidden="false" aria-label="Example home icon">add</mat-icon>
          </button>
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8" style="width: 100%;margin-top: 20px;">
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> SL.No</th>
              <td mat-cell *matCellDef="let element;let i = index"> {{i+1}}</td>
            </ng-container>

            <!-- Name Column -->
            <!-- <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Name
                <mat-form-field class="filter" floatLabel="never" style="margin-left: 15px;">
                  <mat-label>Search by name</mat-label>
                  <input matInput [formControl]="nameFilter">
                </mat-form-field>
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="row">
                  <div class="col">
                    {{element.name}}
                  </div>

                </div>
              </td>
            </ng-container> -->

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;height: 110px; top: 0px; position: sticky; z-index: 100;"> Name
                <div class="form-group" style="position: absolute; padding-top: 37px;">
                    <input type="text" [formControl]="nameFilter" class="form-control" placeholder="search" style="border: 1px solid #888888; width: 70%; border-radius: 8px; margin-top: 20px; margin-left: -7px; height: 31px; text-align: inherit;">
                </div>
              </th>
              <td mat-cell *matCellDef="let element">{{element.name}}</td>
            </ng-container>

            <ng-container matColumnDef="order_expiry_time">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Order Expiry Time

              </th>
              <td mat-cell *matCellDef="let element">
                <div class="row">
                  <div class="col">
                    {{ '2020-01-01 :' + element.order_expiry_time  | date:'shortTime'}}
                  </div>

                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="union">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Union

              </th>
              <td mat-cell *matCellDef="let element">
                <div class="row">
                  <div class="col">
                    {{element.union}}
                  </div>

                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="session">
              <th mat-header-cell *matHeaderCellDef mat-sort-header style="background: #97cdef;"> Session</th>
              <td mat-cell *matCellDef="let element">
                <div class="row">
                  <div class="col">
                    {{element.session_name}}
                  </div>
                  <div class="col">
                    <mat-icon (click)="editRoute(element)">edit</mat-icon>
                  </div>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>

        <div class="col-5" *ngIf="routeService.is_display_route_register_component">
          <div class="row">
            <div class="col"></div>
            <div class="col-1">
              <button mat-fab color="primary" (click)="hideRouteRegister()">
                <i class="material-icons">
                  clear
                </i>

              </button>
            </div>
          </div>
          <app-route-register></app-route-register>
        </div>
      </div>
    </span>
  </div>
</section>
